import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { App } from '@capacitor/app';
import moment from 'moment';

const AppUrlListener = () => {
    let history = useHistory();
    function GetURLParameter(sParam, url )
    {       
        var sURLVariables = url.split('&');
        for (var i = 0; i < sURLVariables.length; i++)
        {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam)
            {
                return sParameterName[1]
                
            }
        }
    }
    useEffect(() => {
        App.addListener('appUrlOpen', (event) => { 
            let urlCompare = event.url.split('?');
        if(urlCompare[0] === `https://${window.location.hostname}/individuales/registrar`){
            let tipodoc = GetURLParameter("tipodoc", event.url) 
            let nrodoc = GetURLParameter("nrodoc", event.url)
            let email = GetURLParameter("email", event.url)
            let nroContrato = GetURLParameter("nrocontrato", event.url)
            let fechaalta = GetURLParameter("fechaalta", event.url )
            let plainPin = GetURLParameter("plainPin", event.url )
            
            const fechaLimite = moment(new Date(parseInt(fechaalta))).add(7, 'days');
            const fechaLimiteTimestamp = moment(new Date(fechaLimite)).unix()
            const fechaActual = moment(new Date()).unix()

                {
                    fechaActual < fechaLimiteTimestamp ? 
                    setTimeout(() => {          
                        history.push({
                          pathname: '/asignacion-contrasenna',
                          state: {  
                            tipoDoc: tipodoc,
                            nroDoc: nrodoc,
                            email: email,
                            nroContrato: nroContrato,
                            plainPin: plainPin
                                }
                      })
                      }, 250) :
                      
                      setTimeout(() => {          
                        history.push('/registracion')
                      }, 250); 
                }
             } 
           }); 
    }, []);
    return null;
  };
  
  export default AppUrlListener;